<template>
  <RouterLink
    :to="`/reviews/${review.id}`"
    class="text-mid-neutral-500 group-hover/row:text-primary-500 group/version"
  >
    <div class="px-2 flex gap-2 h-full w-full items-center">
      <span class="py-3">
        {{ format(review.createdAt, dateFormat + ' HH:mm') }}
      </span>
      <span v-if="versionNameInputModel">•</span>
      <div class="flex items-stretch">
        <input
          ref="inputRef"
          v-model="versionNameInputModel"
          type="text"
          name="version-name"
          class="bg-transparent border-0 p-0 m-0 text-sm focus:outline-none"
          :class="{
            'italic font-medium': review.name !== versionNameInputModel,
            'group-hover/version:opacity-100 opacity-0 focus:opacity-100 ':
              !versionNameInputModel && !review.name,
          }"
          placeholder="Add a version name"
          @keydown.enter.prevent="changeVersionName"
          @blur="changeVersionName"
          @keydown.esc.prevent="discardChanges"
          @click.stop.prevent
        />
      </div>
    </div>
  </RouterLink>
</template>
<script lang="ts" setup>
import { useSettings } from '@app/composables/use-settings'
import { format } from 'date-fns'
import { onMounted, ref, useTemplateRef } from 'vue'
import useProjects from '../../use-projects'
import useLoading from '@app/composables/use-loading'
import useSnackbar from '@app/composables/use-snackbar'

const { review } = defineProps<{
  review: {
    id: number
    createdAt: Date
    isLocked: boolean
    name: string
  }
}>()
onMounted(() => {
  versionNameInputModel.value = review.name
})
const inputElement = useTemplateRef('inputRef')
const { dateFormat } = useSettings()
const versionNameInputModel = ref('')
const { updateReviewVersionName } = useProjects()
const loading = useLoading()
const snackbar = useSnackbar()

async function changeVersionName() {
  if (versionNameInputModel.value === review.name) {
    inputElement.value!.blur()
    return
  }

  loading.start()
  try {
    await updateReviewVersionName({
      reviewId: review.id,
      name: versionNameInputModel.value,
    })
    inputElement.value!.blur()
    snackbar.success('Success')
  } catch (error) {
    console.error('Failed to update review version name', error)
    snackbar.error('Failed to update review version name')
  } finally {
    loading.stop()
  }
}

function discardChanges() {
  versionNameInputModel.value = review.name
}
</script>
